import type { DeleteReviewsReviewIdResponseDto } from './dto';
import type { DeleteReviewsReviewIdParams } from './repository.types';

// DeleteReviewsReviewId
export const mapDeleteReviewsReviewIdModelToRequestDTO = (
  model: DeleteReviewsReviewIdParams,
): DeleteReviewsReviewIdParams => {
  return model;
};

export const mapDeleteReviewsReviewIdResponseDTOToModel = (
  response: DeleteReviewsReviewIdResponseDto,
) => {
  return response;
};
import type { PatchReviewsReviewIdResponseDto } from './dto';
import type { PatchReviewsReviewIdParams } from './repository.types';

// PatchReviewsReviewId
export const mapPatchReviewsReviewIdModelToRequestDTO = (
  model: PatchReviewsReviewIdParams,
): PatchReviewsReviewIdParams => {
  return model;
};

export const mapPatchReviewsReviewIdResponseDTOToModel = (
  response: PatchReviewsReviewIdResponseDto,
) => {
  return response;
};
